const extensions = {
  slack: "png",
  imessage: "png",
  chatgpt: "svg",
  claude: "svg",
  stripe: "svg",
  hubspot: "svg",
  notion: "svg",
  github: "svg",
  gmail: "svg",
} as const;

export function BrandIcon({ name }: { name: keyof typeof extensions }) {
  return (
    <img
      className="g-brand-icon"
      src={`/garden/brands/${name}.${extensions[name]}`}
      width="24"
      height="24"
      alt=""
      loading="lazy"
      decoding="async"
    />
  );
}
